import React, {Component} from 'react';
import { Modal, Button } from 'react-bootstrap';
import { connect} from "remx";
import authStore from '../stores/auth'
import dataStore from "../stores/data"

import broker from "../utils/broker"  

class ModalKategori extends Component {
  constructor(props) {
    super(props);

    this.state = {
        loading: false,   
        remark: '',
        data_kategori: [],
        data_klasifikasi: [],
        data_sub_klasifikasi: [],
        kategori_id:'',
        kategori:'',
        klasifikasi_id: '-',
        klasifikasi : '-',
        sub_klasifikasi_id: '-',
        sub_klasifikasi : '-',
    }
        this.handleSelect = this.handleSelect.bind(this);
        this.saveData = this.saveData.bind(this);
    }

    toggleModalKategori(){
        dataStore.setters.setModalKategori(false)
    }

    getDataKategori(){
        this.setState({ loading: true });
        broker.fetch.get(`list/kategori`).then(res => {
            const { data } = res.data;
            if (data) {
                this.setState({data_kategori : data})
            } else {
                
            }
        }).catch(err => {

        }).then(()=> {

        });
    }

    getDataKlasifikasi(){
        this.setState({ loading: true });
        broker.fetch.get(`list/kategori/${this.state.kategori_id}/klasifikasi`).then(res => {
            const { data } = res.data;
            if (data) {
                this.setState({data_klasifikasi : data})
            } else {
                
            }
        }).catch(err => {

        }).then(()=> {

        });
    }

    getDataSubKlasifikasi(){
        this.setState({ loading: true });
        broker.fetch.get(`list/klasifikasi/${this.state.klasifikasi_id}/sub`).then(res => {
            const { data } = res.data;
            if (data) {
                this.setState({data_sub_klasifikasi : data})
            } else {
                
            }
        }).catch(err => {

        }).then(()=> {

        });
    }

    handleSelect(e){
        var index = e.nativeEvent.target.selectedIndex;
        var text = e.nativeEvent.target[index].text;
        var name = e.target.name;
        this.setState({
            [e.target.name] : text,
            [e.target.id] : e.target.value
        }, function(){
            if ((name) === 'kategori'){
                this.getDataKlasifikasi();
            } else if ((name) === 'klasifikasi'){
                this.getDataSubKlasifikasi();
            }
        })
    }

    componentDidMount(){
        this.getDataKategori();
        // this.getDataKlasifikasi();
        // this.getDataSubKlasifikasi();
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.modal_kategori !== prevProps.modal_kategori && 
            this.props.modal_kategori_data.kategori_id === ''){
                this.setState({data_klasifikasi: [], 
                                data_sub_klasifikasi: [],         
                                kategori_id:'',
                                kategori:'',
                                klasifikasi_id: '-',
                                klasifikasi : '-',
                                sub_klasifikasi_id: '-',
                                sub_klasifikasi : '-'
            });
        }
    }

    saveData(){
        dataStore.setters.setModalKategoriData({
            kategori_id : this.state.kategori_id,
            kategori : this.state.kategori,
            klasifikasi_id : this.state.klasifikasi_id,
            klasifikasi: this.state.klasifikasi,
            sub_klasifikasi_id : this.state.sub_klasifikasi_id,
            sub_klasifikasi : this.state.sub_klasifikasi
        })
        dataStore.setters.setModalKategori(false);
    }

    

    render() {
        return (
            <Modal size="lg" show={dataStore.getters.getModalKategori()} onHide={this.toggleModalKategori} animation={false}>
                <Modal.Header closeButton>
                    <Modal.Title>Pilih Kategori Pelanggan</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <div className="form-group row">
                        <label className="col-sm-3 col-form-label">Kategori</label>
                        <div className="col-sm-9">
                            <select className="custom-select" 
                                    value={this.state.kategori_id}
                                    id="kategori_id"
                                    name="kategori"
                                    onChange={this.handleSelect}
                            >
                                <option value="" disabled>--Pilih Data--</option>
                                {(this.state.data_kategori) && 
                                    this.state.data_kategori.map((data, i) => {  
                                        return <option value={data.id} key={i}>{data.nama}</option>
                                    })
                                }                                
                            </select>
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-sm-3 col-form-label">Klasifikasi</label>
                        <div className="col-sm-9">
                            <select className="custom-select" 
                                    value={this.state.klasifikasi_id}
                                    id="klasifikasi_id"
                                    name="klasifikasi"
                                    onChange={this.handleSelect}
                            >
                                {(this.state.data_klasifikasi) && 
                                    this.state.data_klasifikasi.map((data, i) => {  
                                        return <option value={data.id} key={i}>{data.nama}</option>
                                    })
                                }
                                <option value="-">-</option>
                            </select>
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-sm-3 col-form-label">Sub Klasifikasi</label>
                        <div className="col-sm-9">
                            <select className="custom-select" 
                                    value={this.state.sub_klasifikasi_id}
                                    id="sub_klasifikasi_id"
                                    name="sub_klasifikasi"
                                    onChange={this.handleSelect}
                            >
                                {(this.state.data_sub_klasifikasi) && 
                                    this.state.data_sub_klasifikasi.map((data, i) => {  
                                        return <option value={data.id} key={i}>{data.nama}</option>
                                    })
                                }
                                <option value="-">-</option>
                            </select>
                        </div>
                    </div>
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="secondary" onClick={this.toggleModalKategori}>Batal</Button>
                    <Button variant="primary" onClick={this.saveData}>Simpan</Button>
                </Modal.Footer>
            </Modal>
        );
    }
}

function mapStateToProps(props) {
    return {
        user: authStore.getters.getUser(),
        modal_kategori: dataStore.getters.getModalKategori(),
        modal_kategori_data : dataStore.getters.getModalKategoriData()

    }
  }
export default connect(mapStateToProps)(ModalKategori);

